const SEND_REGISTRATION_INFORMATION_FROM_URL = 'SEND_REGISTRATION_INFORMATION_FROM_URL';
const SEND_STANDARD_REGISTRATION_INFORMATION = 'SEND_STANDARD_REGISTRATION_INFORMATION';

const sendRegistrationEventFromUrl = () => ({
  type: SEND_REGISTRATION_INFORMATION_FROM_URL
});

const sendStandardRegistrationEvent = ({ mpUserId, emailOriginId, registrationSourceId }) => ({
  type: SEND_STANDARD_REGISTRATION_INFORMATION,
  payload: {
    mpUserId,
    emailOriginId,
    registrationSourceId
  }
});

export {
  SEND_REGISTRATION_INFORMATION_FROM_URL,
  SEND_STANDARD_REGISTRATION_INFORMATION,
  sendRegistrationEventFromUrl,
  sendStandardRegistrationEvent
};
